module.exports = __webpack_public_path__ + "static/media/preloader-2.ed236853.gif";